import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=7bafaa50&scoped=true&"
import script from "./BaseAvatar.vue?vue&type=script&lang=js&"
export * from "./BaseAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=7bafaa50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafaa50",
  null
  
)

export default component.exports